import * as React from 'react'
import styled from 'styled-components'

const Header = () => {
  return (
    <PrintHeader className="print-header">
      <BackgroundImage src="https://uci-images.s3-us-west-1.amazonaws.com/css/printbg.svg" className="img-fluid pb-4"/>
    </PrintHeader>
  )
}

const PrintHeader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: #1A4C7A;
  border-color: transparent;
`

const BackgroundImage = styled.img`
  ${(props) =>
  props.onClick && {
    cursor: 'pointer',
  }
  };
`

export default Header



// WEBPACK FOOTER //
// ./src/atoms/PrintHeader/PrintHeader.tsx